module.exports = __webpack_require__.p + "7c8a97633cafb631b5256e30323a96f6.jpg";